export default (function($) {
    'use strict';

    $(document).ready(function() {
        $('.featured-event-slick').slick({
            dots: true,
            arrows: false,
            appendDots: $(".slide-m-dots"),
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
        });        
    });
})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/featured-events-block.js